.srciButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 126px;
  aspect-ratio: 178 / 32;
  margin: 0 0 4px;
  padding: 8px 18px;
  border: 1px solid #000000;
  border-radius: 1000px;
  background: #000000;
  cursor: pointer;
}

.srciButton:focus-visible {
  outline: 2px solid #16182b;
  outline-offset: 2px;
}

.small {
  --srci-button-asset-height: 18px;

  width: 178px;
  padding-block: 6px;
}

.medium {
  --srci-button-asset-height: 23.25px;

  width: 230px;
}

.big {
  --srci-button-asset-height: 30.25px;

  width: 300px;
}

.buttonInside {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 5px;
}

.buttonAsset {
  display: block;
  flex: 0 0 auto;
  width: auto;
  height: var(--srci-button-asset-height);
}
